var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.areaid)?_c('div',[_c('img',{attrs:{"src":require('@/images/svg/' + _vm.getIcon(_vm.areaid).src),"height":"180","title":_vm.getIcon(_vm.areaid).title}})]):_c('div',[_vm._v(" "+_vm._s(_vm.areaid)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }